function getProvinceName(municipalityId) {
  const provinceByPrefix = {
    1: 'Antwerpen',
    2: 'Vlaams-Brabant',
    3: 'West-Vlaanderen',
    4: 'Oost-Vlaanderen',
    7: 'Limburg',
  };

  return provinceByPrefix[String(municipalityId).charAt(0)] || '-';
}

export {
  getProvinceName,
};
